<!-- 店铺报表 -->

<template>
    <div class="statement">
        <div class="statement-inner-box">
            <div class="pie clearfix">
                <!-- <div class="totalMsg" @click.stop="nowDataType='DAY'">
                    <div :class="nowDataType=='DAY'?'totalMsgInner active':'totalMsgInner'">
                        昨日
                    </div>
                </div> -->
                <div class="totalMsg" @click.stop="nowDataType='SEVEN'">
                    <div :class="nowDataType=='SEVEN'?'totalMsgInner active':'totalMsgInner'">
                        最近7天
                    </div>
                </div>
                 <div class="totalMsg" @click.stop="nowDataType='FIFTEEN'">
                    <div :class="nowDataType=='FIFTEEN'?'totalMsgInner active':'totalMsgInner'">
                        最近15天
                    </div>
                </div>
                <div class="totalMsg" @click.stop="nowDataType='THIRTY'">
                    <div :class="nowDataType=='THIRTY'?'totalMsgInner active':'totalMsgInner'">
                        最近30天
                    </div>
                </div>
                <div class="totalMsg titinfo">
                    <span><i>● 每条曲线对应一个分类</i><br><i> ● 鼠标停留在圆点展示每个分类数据</i></span>
                    <span><i> ● 每个圆点对应当天分类销售额</i><br><i> ● 点击分类名可关闭或单独显示某个分类数据</i></span>
                </div>
                <!-- <div id="pie" class="left"></div> -->
                <!-- <div class="right-info left" style="width:60%;">
                    <div class="flex flex-align-center flex-box">
                        <div class="flex-inner">
                            <div class="left right-info-item" @click="$router.push(`/sys/${$route.params.id}/lostVip/LOST`)" style="cursor:pointer;">
                                <p class="title">流失会员</p>
                                <p class="num" v-text="aDates.lost_count" style="color:#ff9494;"></p>
                                <p class="tex">连续15天未消费</p>
                            </div>
                            <div class="left right-info-item">
                                <p class="title">活跃会员</p>
                                <p class="num" v-text="aDates.active_count"></p>
                                <p class="tex">昨日有消费</p>
                            </div>
                            <div class="left right-info-item">
                                <p class="title" >新增会员</p>
                                <p class="num" v-text="aDates.new_count" style="color:#72f6c6;"></p>
                                <p class="tex">昨日新增</p>
                            </div>
                            <div class="left right-info-item" @click="$router.push(`/sys/${$route.params.id}/lostVip/ALL`)" style="cursor:pointer;">
                                <p class="title" >总会员数</p>
                                <p class="num" v-text="aDates.total" style="color:#44e2ff;"></p>
                                <p class="tex">包含不活跃</p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="space"></div>
            <div class="histogram-wrap">
                <!-- <div class="halfYearData clearfix">
                    <div class="left title flex flex-align-center">
                        <p style="background-color: #3067ff; width: 100px;height: 32px;line-height: 32px; border-radius: 16px;color:#fff;font-size: 14px;text-align:center;">{{nowDataType}}</p>
                    </div>
                </div> -->
                <div id="histogram"></div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import echarts from 'echarts';
    import _ from 'lodash'
    export default{
        props: ['curStoreId','storeData'],
        data () {
            return {
                //
                seriesData:[],
                xAxisData:[],//日期数据
                legendData:[],//分类数据
                nowDataType:"SEVEN",
                // 
                histogram: null,//柱状图
                pie: null,//饼状图
                // storeData:{},//当前店铺信息
                totalData: {
                    total: 0, // 实收
                    cash: 0, // 现金
                    wechat: 0, // 微信
                    alipay: 0, // 支付宝
                }, // 半年数据总和
                dates:[],
                aDates:{}
            }
        },
        watch: {
            nowDataType(val){
                this.getData(val);
            }
        },
        methods: {
            getData(val){
                this.$http({
                    url:"get-day",
                    method:"GET",
                    params:{
                        storeId:this.curStoreId,
                        type:val,
                    }
                }).then(res=>{
                    if(res.data.code == 200){
                        if(res.data.data.length){
                            let data = res.data.data;
                            let legendData = [];
                            let xAxisData = [];
                            let seriesData = [];
                            // 筛选分类数据和日期
                            for(let i=0;i<data.length;i++){
                                xAxisData.push(data[i].date);
                                for(let j=0;j<data[i].list.length;j++){
                                    if(legendData.length){
                                        let flag = false;
                                        for(let y=0;y<legendData.length;y++){
                                            if(legendData[y]==data[i].list[j].typeName){
                                                flag = true;
                                            }
                                        }
                                        if(!flag){
                                            legendData.push(data[i].list[j].typeName)
                                        }
                                    }else{
                                        if(data[i].list[j]){
                                            legendData.push(data[i].list[j].typeName)
                                        }
                                    }
                                }
                            }
                            // 按照分类来筛选每个分类的具体时间销售金额
                            for(let i=0;i<legendData.length;i++){
                                let obj = {
                                    name:legendData[i],
                                    type:"line",
                                    // stack: '总量',
                                    data:[],
                                }
                                seriesData.push(obj);
                            }
                            // // // 重新整理数据
                            // let newData = [];
                            // for(let i=0;i<data.length;i++){
                            //     if(data[i].list.length){
                            //         let obj = {
                            //             date:data[i].date,
                            //             list:[]
                            //         }
                            //         for(let x=0;x<seriesData.length;x++){
                            //             for(let j=0;j<data[i].list.length;j++){
                            //                 if(seriesData[x].name == data[i].list[j].typeName){
                            //                     obj.list.push({
                            //                         amount:data[i].list[j].amount,
                            //                         date: "",
                            //                         id: 0,
                            //                         qty: data[i].list[j].qty,
                            //                         storeId: "",
                            //                         typeName: seriesData[x].name,
                            //                     });
                            //                 }
                            //             }
                            //         }
                            //         newData.push(obj);
                            //     }else{
                            //         let obj = {
                            //             date:data[i].date,
                            //             list:[]
                            //         }
                            //        for(let x=0;x<seriesData.length;x++){
                            //             obj.list.push({
                            //                 amount:0,
                            //                 date: "",
                            //                 id: 0,
                            //                 qty: 0,
                            //                 storeId: "",
                            //                 typeName: seriesData[x].name,
                            //             });
                            //        } 
                            //         newData.push(obj);
                            //     }
                                
                            // }
                            // console.log(newData);
                            // return;
                            for(let i=0;i<seriesData.length;i++){
                                for(let j=0;j<data.length;j++){
                                    for(let x=0;x<data[j].list.length;x++){
                                        if(seriesData[i].name == data[j].list[x].typeName){
                                            seriesData[i].data.push(`${data[j].list[x].amount}`);
                                        }
                                    }
                                }
                            }
                            // for(let i=0;i<seriesData.length;i++){
                            //     for(let j=0;j<newData.length;j++){
                            //         for(let x=0;x<newData[j].list.length;x++){
                            //             if(seriesData[i].name == newData[j].list[x].typeName){
                            //                 seriesData[i].data.push(`${newData[j].list[x].amount}`);
                            //             }
                            //         }
                            //     }
                            // }
                            console.log("分类数据：")
                            console.log(legendData)
                            console.log("日期数据：")
                            console.log(xAxisData)
                            console.log("数据：")
                            console.log(seriesData)
                            this.legendData = legendData;
                            this.seriesData = seriesData;
                            this.xAxisData = xAxisData;
                            if(val=="SEVEN" || val=="FIFTEEN"){
                                this.drawLine(legendData,xAxisData,seriesData);
                            }else{
                                this.drawLine(legendData,xAxisData,seriesData,true);
                            }
                        }
                    }
                });
            },
            drawLine(legendData,xAxisData,seriesData,isRotate=false){
                let axisLabelData = {};
                if(!isRotate){
                    axisLabelData = {
                        interval:0,
                        rotate:0
                    }
                }else{
                    axisLabelData = {
                        interval:0,
                        rotate:45
                    }
                }
                let othis = this;
                if ( this.histogram ) {
                    this.histogram.dispose();
                }
                this.histogram = echarts.init(document.getElementById('histogram'));
                setTimeout(function(){
                    //setTimeout避免拿不到店铺信息
                    othis.histogram.setOption({
                        title: {
                            text: '金额',
                            top:20
                        },
                        color: ["#ff9494", "#72f6c6", "#769aff","#7c2222","#6c57d9","#261095","#7c5708","#f1a80b","#42cf7e","#3b5245","#de3b0f","#4e3e08","#df4aa5","#c852bc","#230f62","#8d0d40","#542200","#b44b06","#f94e62","#000000"],
                        tooltip: {
                            trigger: 'axis',
                            formatter:  (params) => {  // params为悬浮框上的全部数据
                                console.log(params);
                                // return;
                                const newParams = [];
                                
                                let paramsData = _.sortBy(params, 'value'); // 根据value值升序，_.sortBy为lodash的方法
                                console.log(paramsData)
                                paramsData = _.reverse(paramsData);  // 将数据降序，_.reverse为lodash的方法

                                paramsData.sort((a,b)=>{
                                    return Number(b.value) - Number(a.value)
                                })

                                paramsData.forEach((p) => {
                                    // p.marker为对应数据线的颜色的圆点 
                                    // p.seriesName为对应数据的数据名称
                                    // p.value为对应数据的值
                                    const cont = p.marker + ' ' + p.seriesName + ': ' + p.value + ' 元<br/>';
                                    newParams.push(cont);
                                });
                                return _.join(newParams, '');  // 这里是需要将数组转化成字符串显示，如果不转化，每个数据前面都会出现一个逗号（，），_.join为lodash的方法
                            }
                        },
                        legend: {
                            type:"scroll",
                            data:legendData,
                            top :0
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        // toolbox: {
                        //     feature: {
                        //         saveAsImage: {}
                        //     }
                        // },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: xAxisData,
                            axisLabel: axisLabelData
                            // max:"dataMax",
                            // splitNumber:1,
                            // boundaryGap:['3%','3%'],
                            // maxInterval:3600 * 24 * 1000
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: seriesData
                    });
                },200)
            },
            drawPie(datas){
                let storeName = this.storeData.name;
                let othis = this;
                let seriesData = [
                    {value:datas.lost_count, name:'流失'},
                    {value:datas.new_count, name:'新增'},
                    {value:datas.active_count, name:'活跃'}
                ];
                if ( this.pie ) {
                    this.pie.dispose();
                }
                this.pie = echarts.init(document.getElementById('pie'));
                setTimeout(function(){
                    othis.pie.setOption({
                        tooltip: {
                            trigger: 'item',
                            formatter: "{a} <br/>{b}: {c} ({d}%)"
                        },
                        color: ["#ff9494", "#72f6c6", "#769aff"],
                        legend: {
                            orient: 'horizontal',
                            // x: 'left',
                            bottom:'2%',
                            data:['流失','新增','活跃']
                        },
                        series: [
                            {
                                name:storeName,
                                type:'pie',
                                radius: ['50%', '70%'],
                                avoidLabelOverlap: false,
                                label: {
                                    normal: {
                                        show: false,
                                        position: 'center'
                                    },
                                    emphasis: {
                                        show: true,
                                        formatter:'{c}',
                                        textStyle: {
                                            fontSize: '30',
                                            fontWeight: 'bold'
                                        }
                                    }
                                },
                                labelLine: {
                                    normal: {
                                        show: false
                                    }
                                },
                                data:seriesData
                            }
                        ]
                    });
                },200)
            },
            //柱状图
            drawHistogram ( datas ) {
                let othis = this;
                let newCountArr =  [];//新增
                let activeCountArr =  [];//活跃
                let lostCountArr =  [];//流失
                let monthArr =  [];//每月总销售额数据数组

                let sssss=[];
                for(let i = 0,len = datas.length; i < len;i++){
                    //获取每月总销售额
                    newCountArr.push(datas[i].new_count);
                    activeCountArr.push(datas[i].active_count);
                    lostCountArr.push(datas[i].lost_count);
                    monthArr.push((new Date(datas[i].biz_date).getMonth()+1)+'-'+new Date(datas[i].biz_date).getDate());
                }
                if ( this.histogram ) {
                    this.histogram.dispose();
                }
                this.histogram = echarts.init(document.getElementById('histogram'));
                setTimeout(function(){
                    //setTimeout避免拿不到店铺信息
                    othis.histogram.setOption({
                        tooltip: {},
                        color: ["#87a2ea"],
                        legend: {
                            data:['流失','新增','活跃'],
                            y: 'bottom',
                        },
                        grid: {
                            left: '3%',
                            right: '3%',
                            bottom: '10%',
                            top: '8%',
                            containLabel: true
                        },
                        xAxis: {
                            data: monthArr,
                            axisLine: {
                                show: true, 
                                lineStyle: {
                                    color: "#ddd"
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#444"
                                }
                            },
                            type: 'category',
                            // boundaryGap: false,
                        },
                        yAxis: {
                            type: 'value',
                            splitLine: {
                                show:true,
                                lineStyle: {
                                    type: 'dashed',
                                    color: '#ddd'
                                }
                            },
                            axisLine: {
                                show: false, 
                            },
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                textStyle: {
                                    color: "#444",
                                    fontSize: 12
                                }
                            }
                        },
                        series: [
                        {
                            color: ["#ff9494"],
                            name: '流失',
                            type: 'bar',
                            barWidth: '15%',
                            data: lostCountArr,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [5, 5, 0, 0]
                                },
                                emphasis: {
                                    // backgroundImage: linearGradient(to bottom, #30bdff, #3068ff)
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'outside',
                                    formatter: '{c}' // 这里是数据展示的时候显示的数据
                                }
                            },
                        },
                        {
                            name: '新增',
                            color: ["#72f6c6"],
                            type: 'bar',
                            barWidth: '15%',
                            data: newCountArr,
                            itemStyle: {
                                normal: {
                                    barBorderRadius: [5, 5, 0, 0]
                                },
                                emphasis: {
                                    // backgroundImage: linearGradient(to bottom, #30bdff, #3068ff)
                                }
                            },
                            label: {
                                normal: {
                                    show: true,
                                    position: 'outside',
                                    formatter: '{c}' // 这里是数据展示的时候显示的数据
                                }
                            },
                        },
                        {
                            name:'活跃',
                            type:'line',
                            data:activeCountArr,
                            smooth:true,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'outside',
                                    formatter: '{c}' // 这里是数据展示的时候显示的数据
                                }
                            },
                        },
                        ]
                    });
                },200)
            },
        },
        created(){
        },
        mounted: function () {
            this.getData("SEVEN");
            console.log(_.sortBy)
            // this.storeData.name = this.storeData.name;
            // this.$http.get(this.curStoreId+'/daily-member-statics').then((res)=>{
            //     this.dates = res.data;
            //     for(var i = 0,len=7-res.data.length;i<len;i++){
            //         let obj = {
            //             active_count:0,
            //             biz_date:(new Date().getTime()-24*3600*1000*(7-i)),
            //             lost_count:0,
            //             new_count:0,
            //             sleep_count:0,
            //             total:0
            //         }
            //         this.dates.splice(i,0,obj);
            //     }
            //     this.drawPie(this.dates[this.dates.length-1]);
            //     this.aDates = this.dates[this.dates.length-1];
            //     this.drawHistogram(this.dates);
            // })
            
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import "statement.scss";
</style>



// WEBPACK FOOTER //
// statement.vue?00d94a88